import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _411b3d08 = () => interopDefault(import('../pages/app-update/index.vue' /* webpackChunkName: "pages/app-update/index" */))
const _6e036c8a = () => interopDefault(import('../pages/audit.vue' /* webpackChunkName: "pages/audit" */))
const _1d455004 = () => interopDefault(import('../pages/audit/index.vue' /* webpackChunkName: "pages/audit/index" */))
const _400aedae = () => interopDefault(import('../pages/audit/company.vue' /* webpackChunkName: "pages/audit/company" */))
const _79c42fb6 = () => interopDefault(import('../pages/audit/failure.vue' /* webpackChunkName: "pages/audit/failure" */))
const _38d91859 = () => interopDefault(import('../pages/audit/person.vue' /* webpackChunkName: "pages/audit/person" */))
const _c13e8a48 = () => interopDefault(import('../pages/audit/review.vue' /* webpackChunkName: "pages/audit/review" */))
const _04cf71a7 = () => interopDefault(import('../pages/audit/submitted.vue' /* webpackChunkName: "pages/audit/submitted" */))
const _9aa14ca2 = () => interopDefault(import('../pages/audit/success.vue' /* webpackChunkName: "pages/audit/success" */))
const _4934977b = () => interopDefault(import('../pages/chiefChatroom/index.vue' /* webpackChunkName: "pages/chiefChatroom/index" */))
const _741939d0 = () => interopDefault(import('../pages/chiefCircle/index.vue' /* webpackChunkName: "pages/chiefCircle/index" */))
const _0d3db529 = () => interopDefault(import('../pages/column/index.vue' /* webpackChunkName: "pages/column/index" */))
const _37e4da10 = () => interopDefault(import('../pages/hotpost/index.vue' /* webpackChunkName: "pages/hotpost/index" */))
const _a58ab01c = () => interopDefault(import('../pages/hotspot/index.vue' /* webpackChunkName: "pages/hotspot/index" */))
const _4c483d3f = () => interopDefault(import('../pages/live/index.vue' /* webpackChunkName: "pages/live/index" */))
const _2cd40e8f = () => interopDefault(import('../pages/market/index.vue' /* webpackChunkName: "pages/market/index" */))
const _265ce32a = () => interopDefault(import('../pages/message/index.vue' /* webpackChunkName: "pages/message/index" */))
const _541a9fa6 = () => interopDefault(import('../pages/myStock/index.vue' /* webpackChunkName: "pages/myStock/index" */))
const _fba9bb34 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _dd4d2b8a = () => interopDefault(import('../pages/official.vue' /* webpackChunkName: "pages/official" */))
const _4309164c = () => interopDefault(import('../pages/recommend-users/index.vue' /* webpackChunkName: "pages/recommend-users/index" */))
const _65ac8cc4 = () => interopDefault(import('../pages/recruit.vue' /* webpackChunkName: "pages/recruit" */))
const _596c08fb = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _e07863e2 = () => interopDefault(import('../pages/subject/index.vue' /* webpackChunkName: "pages/subject/index" */))
const _1eddb086 = () => interopDefault(import('../pages/system-error/index.vue' /* webpackChunkName: "pages/system-error/index" */))
const _6e4a63ae = () => interopDefault(import('../pages/tradeHeadlines/index.vue' /* webpackChunkName: "pages/tradeHeadlines/index" */))
const _0e9cddeb = () => interopDefault(import('../pages/activity/20200928.vue' /* webpackChunkName: "pages/activity/20200928" */))
const _d1eb4878 = () => interopDefault(import('../pages/activity/20201009.vue' /* webpackChunkName: "pages/activity/20201009" */))
const _cbc10008 = () => interopDefault(import('../pages/activity/20201023.vue' /* webpackChunkName: "pages/activity/20201023" */))
const _68abbd00 = () => interopDefault(import('../pages/activity/20201104.vue' /* webpackChunkName: "pages/activity/20201104" */))
const _e39e1c76 = () => interopDefault(import('../pages/activity/20220117.vue' /* webpackChunkName: "pages/activity/20220117" */))
const _a2b2c29c = () => interopDefault(import('../pages/black-gold/promote/index.vue' /* webpackChunkName: "pages/black-gold/promote/index" */))
const _52aa138e = () => interopDefault(import('../pages/column/columnist/index.vue' /* webpackChunkName: "pages/column/columnist/index" */))
const _8d9530f8 = () => interopDefault(import('../pages/fundHomeV2/etfSubject.vue' /* webpackChunkName: "pages/fundHomeV2/etfSubject" */))
const _2e42474e = () => interopDefault(import('../pages/fundHomeV2/watchlist.vue' /* webpackChunkName: "pages/fundHomeV2/watchlist" */))
const _33bdd657 = () => interopDefault(import('../pages/huiluyan/index/index.vue' /* webpackChunkName: "pages/huiluyan/index/index" */))
const _2f82cf76 = () => interopDefault(import('../pages/intro/portfolio.vue' /* webpackChunkName: "pages/intro/portfolio" */))
const _1af71e4e = () => interopDefault(import('../pages/member/blackgold-intro.vue' /* webpackChunkName: "pages/member/blackgold-intro" */))
const _deee91b8 = () => interopDefault(import('../pages/member/chanceNotice/index.vue' /* webpackChunkName: "pages/member/chanceNotice/index" */))
const _3d98e88e = () => interopDefault(import('../pages/member/column/index.vue' /* webpackChunkName: "pages/member/column/index" */))
const _5ac88127 = () => interopDefault(import('../pages/member/coreCapital/index.vue' /* webpackChunkName: "pages/member/coreCapital/index" */))
const _f10e4136 = () => interopDefault(import('../pages/member/failure.vue' /* webpackChunkName: "pages/member/failure" */))
const _0e1fc33b = () => interopDefault(import('../pages/member/infoSwiper.vue' /* webpackChunkName: "pages/member/infoSwiper" */))
const _9fa77c3e = () => interopDefault(import('../pages/member/payment.vue' /* webpackChunkName: "pages/member/payment" */))
const _2d809768 = () => interopDefault(import('../pages/member/privilege.vue' /* webpackChunkName: "pages/member/privilege" */))
const _f74e1c60 = () => interopDefault(import('../pages/member/privilegeintro.vue' /* webpackChunkName: "pages/member/privilegeintro" */))
const _7f37ed44 = () => interopDefault(import('../pages/member/success.vue' /* webpackChunkName: "pages/member/success" */))
const _a6843922 = () => interopDefault(import('../pages/member/type.vue' /* webpackChunkName: "pages/member/type" */))
const _d5b04a9c = () => interopDefault(import('../pages/member/type/index.vue' /* webpackChunkName: "pages/member/type/index" */))
const _07a5869b = () => interopDefault(import('../pages/member/type/article-index.vue' /* webpackChunkName: "pages/member/type/article-index" */))
const _6dec06a3 = () => interopDefault(import('../pages/member/usualQuestion.vue' /* webpackChunkName: "pages/member/usualQuestion" */))
const _09de7dcc = () => interopDefault(import('../pages/my/comment.vue' /* webpackChunkName: "pages/my/comment" */))
const _e832f66e = () => interopDefault(import('../pages/my/coupon.vue' /* webpackChunkName: "pages/my/coupon" */))
const _2478b47f = () => interopDefault(import('../pages/my/favorite.vue' /* webpackChunkName: "pages/my/favorite" */))
const _d53e0bfe = () => interopDefault(import('../pages/my/follower.vue' /* webpackChunkName: "pages/my/follower" */))
const _32f35084 = () => interopDefault(import('../pages/my/following.vue' /* webpackChunkName: "pages/my/following" */))
const _67da547c = () => interopDefault(import('../pages/my/publish.vue' /* webpackChunkName: "pages/my/publish" */))
const _d18c9538 = () => interopDefault(import('../pages/my/purchase.vue' /* webpackChunkName: "pages/my/purchase" */))
const _71287f79 = () => interopDefault(import('../pages/my/reading.vue' /* webpackChunkName: "pages/my/reading" */))
const _f5978586 = () => interopDefault(import('../pages/my/setting.vue' /* webpackChunkName: "pages/my/setting" */))
const _04896443 = () => interopDefault(import('../pages/my/stock.vue' /* webpackChunkName: "pages/my/stock" */))
const _00febb36 = () => interopDefault(import('../pages/portfolio/create/index.vue' /* webpackChunkName: "pages/portfolio/create/index" */))
const _63109e7e = () => interopDefault(import('../pages/topics/popular/index.vue' /* webpackChunkName: "pages/topics/popular/index" */))
const _4b9933be = () => interopDefault(import('../pages/user/member.vue' /* webpackChunkName: "pages/user/member" */))
const _06e089ec = () => interopDefault(import('../pages/black-gold/industry-revival/intro.vue' /* webpackChunkName: "pages/black-gold/industry-revival/intro" */))
const _6ee2d468 = () => interopDefault(import('../pages/activity/20211115/_id.vue' /* webpackChunkName: "pages/activity/20211115/_id" */))
const _0072cab4 = () => interopDefault(import('../pages/activity/kefu/_id.vue' /* webpackChunkName: "pages/activity/kefu/_id" */))
const _389cd00e = () => interopDefault(import('../pages/black-gold/industry-revival/_columnId.vue' /* webpackChunkName: "pages/black-gold/industry-revival/_columnId" */))
const _1e4fd9a9 = () => interopDefault(import('../pages/chiefCircle/detail/_id/index.vue' /* webpackChunkName: "pages/chiefCircle/detail/_id/index" */))
const _dfe7e4a0 = () => interopDefault(import('../pages/chiefCircle/guide/_id/index.vue' /* webpackChunkName: "pages/chiefCircle/guide/_id/index" */))
const _7732fa80 = () => interopDefault(import('../pages/chiefCircle/search/_id/index.vue' /* webpackChunkName: "pages/chiefCircle/search/_id/index" */))
const _66854e9a = () => interopDefault(import('../pages/column/page/_id.vue' /* webpackChunkName: "pages/column/page/_id" */))
const _71a7f581 = () => interopDefault(import('../pages/community/post/_id.vue' /* webpackChunkName: "pages/community/post/_id" */))
const _8f407af6 = () => interopDefault(import('../pages/community/topics/_id.vue' /* webpackChunkName: "pages/community/topics/_id" */))
const _5e75e94d = () => interopDefault(import('../pages/market/hotRange/_type.vue' /* webpackChunkName: "pages/market/hotRange/_type" */))
const _d19fc6b0 = () => interopDefault(import('../pages/market/marketRange/_type.vue' /* webpackChunkName: "pages/market/marketRange/_type" */))
const _056ac166 = () => interopDefault(import('../pages/member/coreCapital/_stockId.vue' /* webpackChunkName: "pages/member/coreCapital/_stockId" */))
const _734ef354 = () => interopDefault(import('../pages/news/page/_id.vue' /* webpackChunkName: "pages/news/page/_id" */))
const _8fd4b4dc = () => interopDefault(import('../pages/member/articles/_groupId/_subGroupId.vue' /* webpackChunkName: "pages/member/articles/_groupId/_subGroupId" */))
const _77220750 = () => interopDefault(import('../pages/portfolio/create/_type/_portfolioCode.vue' /* webpackChunkName: "pages/portfolio/create/_type/_portfolioCode" */))
const _7782674a = () => interopDefault(import('../pages/portfolio/edit/_type/_portfolioCode.vue' /* webpackChunkName: "pages/portfolio/edit/_type/_portfolioCode" */))
const _94aab3a0 = () => interopDefault(import('../pages/album/_columnId.vue' /* webpackChunkName: "pages/album/_columnId" */))
const _fe6330a4 = () => interopDefault(import('../pages/chatroom/_id.vue' /* webpackChunkName: "pages/chatroom/_id" */))
const _451bfdd7 = () => interopDefault(import('../pages/hotpost/_type.vue' /* webpackChunkName: "pages/hotpost/_type" */))
const _4a54024c = () => interopDefault(import('../pages/hotspot/_id.vue' /* webpackChunkName: "pages/hotspot/_id" */))
const _0ef28367 = () => interopDefault(import('../pages/live/_id.vue' /* webpackChunkName: "pages/live/_id" */))
const _6be268b7 = () => interopDefault(import('../pages/market/_id.vue' /* webpackChunkName: "pages/market/_id" */))
const _86147850 = () => interopDefault(import('../pages/member/_id/index.vue' /* webpackChunkName: "pages/member/_id/index" */))
const _4a6af364 = () => interopDefault(import('../pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _080de57b = () => interopDefault(import('../pages/p/_id.vue' /* webpackChunkName: "pages/p/_id" */))
const _b264f2d4 = () => interopDefault(import('../pages/portfolio/_id/index.vue' /* webpackChunkName: "pages/portfolio/_id/index" */))
const _b4841eb2 = () => interopDefault(import('../pages/rss-detail/_id.vue' /* webpackChunkName: "pages/rss-detail/_id" */))
const _22159bbe = () => interopDefault(import('../pages/stock/_id.vue' /* webpackChunkName: "pages/stock/_id" */))
const _1ebc0837 = () => interopDefault(import('../pages/subject/_id.vue' /* webpackChunkName: "pages/subject/_id" */))
const _b522e01a = () => interopDefault(import('../pages/tags/_type.vue' /* webpackChunkName: "pages/tags/_type" */))
const _7c972346 = () => interopDefault(import('../pages/terms/_page.vue' /* webpackChunkName: "pages/terms/_page" */))
const _73b96f46 = () => interopDefault(import('../pages/user/_id.vue' /* webpackChunkName: "pages/user/_id" */))
const _dfae61c6 = () => interopDefault(import('../pages/portfolio/_id/follow.vue' /* webpackChunkName: "pages/portfolio/_id/follow" */))
const _5033e44e = () => interopDefault(import('../pages/portfolio/_id/revenue-analysis.vue' /* webpackChunkName: "pages/portfolio/_id/revenue-analysis" */))
const _30d316fc = () => interopDefault(import('../pages/member/_id/_childId.vue' /* webpackChunkName: "pages/member/_id/_childId" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _70174796 = () => interopDefault(import('../pages/index/index.vue' /* webpackChunkName: "pages/index/index" */))
const _5741ee47 = () => interopDefault(import('../pages/index/tag/_type.vue' /* webpackChunkName: "pages/index/tag/_type" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/app-update",
    component: _411b3d08,
    name: "app-update"
  }, {
    path: "/audit",
    component: _6e036c8a,
    children: [{
      path: "",
      component: _1d455004,
      name: "audit"
    }, {
      path: "company",
      component: _400aedae,
      name: "audit-company"
    }, {
      path: "failure",
      component: _79c42fb6,
      name: "audit-failure"
    }, {
      path: "person",
      component: _38d91859,
      name: "audit-person"
    }, {
      path: "review",
      component: _c13e8a48,
      name: "audit-review"
    }, {
      path: "submitted",
      component: _04cf71a7,
      name: "audit-submitted"
    }, {
      path: "success",
      component: _9aa14ca2,
      name: "audit-success"
    }]
  }, {
    path: "/chiefChatroom",
    component: _4934977b,
    name: "chiefChatroom"
  }, {
    path: "/chiefCircle",
    component: _741939d0,
    name: "chiefCircle"
  }, {
    path: "/column",
    component: _0d3db529,
    name: "column"
  }, {
    path: "/hotpost",
    component: _37e4da10,
    name: "hotpost"
  }, {
    path: "/hotspot",
    component: _a58ab01c,
    name: "hotspot"
  }, {
    path: "/live",
    component: _4c483d3f,
    name: "live"
  }, {
    path: "/market",
    component: _2cd40e8f,
    name: "market"
  }, {
    path: "/message",
    component: _265ce32a,
    name: "message"
  }, {
    path: "/myStock",
    component: _541a9fa6,
    name: "myStock"
  }, {
    path: "/news",
    component: _fba9bb34,
    name: "news"
  }, {
    path: "/official",
    component: _dd4d2b8a,
    name: "official"
  }, {
    path: "/recommend-users",
    component: _4309164c,
    name: "recommend-users"
  }, {
    path: "/recruit",
    component: _65ac8cc4,
    name: "recruit"
  }, {
    path: "/search",
    component: _596c08fb,
    name: "search"
  }, {
    path: "/subject",
    component: _e07863e2,
    name: "subject"
  }, {
    path: "/system-error",
    component: _1eddb086,
    name: "system-error"
  }, {
    path: "/tradeHeadlines",
    component: _6e4a63ae,
    name: "tradeHeadlines"
  }, {
    path: "/activity/20200928",
    component: _0e9cddeb,
    name: "activity-20200928"
  }, {
    path: "/activity/20201009",
    component: _d1eb4878,
    name: "activity-20201009"
  }, {
    path: "/activity/20201023",
    component: _cbc10008,
    name: "activity-20201023"
  }, {
    path: "/activity/20201104",
    component: _68abbd00,
    name: "activity-20201104"
  }, {
    path: "/activity/20220117",
    component: _e39e1c76,
    name: "activity-20220117"
  }, {
    path: "/black-gold/promote",
    component: _a2b2c29c,
    name: "black-gold-promote"
  }, {
    path: "/column/columnist",
    component: _52aa138e,
    name: "column-columnist"
  }, {
    path: "/fundHomeV2/etfSubject",
    component: _8d9530f8,
    name: "fundHomeV2-etfSubject"
  }, {
    path: "/fundHomeV2/watchlist",
    component: _2e42474e,
    name: "fundHomeV2-watchlist"
  }, {
    path: "/huiluyan/index",
    component: _33bdd657,
    name: "huiluyan-index"
  }, {
    path: "/intro/portfolio",
    component: _2f82cf76,
    name: "intro-portfolio"
  }, {
    path: "/member/blackgold-intro",
    component: _1af71e4e,
    name: "member-blackgold-intro"
  }, {
    path: "/member/chanceNotice",
    component: _deee91b8,
    name: "member-chanceNotice"
  }, {
    path: "/member/column",
    component: _3d98e88e,
    name: "member-column"
  }, {
    path: "/member/coreCapital",
    component: _5ac88127,
    name: "member-coreCapital"
  }, {
    path: "/member/failure",
    component: _f10e4136,
    name: "member-failure"
  }, {
    path: "/member/infoSwiper",
    component: _0e1fc33b,
    name: "member-infoSwiper"
  }, {
    path: "/member/payment",
    component: _9fa77c3e,
    name: "member-payment"
  }, {
    path: "/member/privilege",
    component: _2d809768,
    name: "member-privilege"
  }, {
    path: "/member/privilegeintro",
    component: _f74e1c60,
    name: "member-privilegeintro"
  }, {
    path: "/member/success",
    component: _7f37ed44,
    name: "member-success"
  }, {
    path: "/member/type",
    component: _a6843922,
    children: [{
      path: "",
      component: _d5b04a9c,
      name: "member-type"
    }, {
      path: "article-index",
      component: _07a5869b,
      name: "member-type-article"
    }]
  }, {
    path: "/member/usualQuestion",
    component: _6dec06a3,
    name: "member-usualQuestion"
  }, {
    path: "/my/comment",
    component: _09de7dcc,
    name: "my-comment"
  }, {
    path: "/my/coupon",
    component: _e832f66e,
    name: "my-coupon"
  }, {
    path: "/my/favorite",
    component: _2478b47f,
    name: "my-favorite"
  }, {
    path: "/my/follower",
    component: _d53e0bfe,
    name: "my-follower"
  }, {
    path: "/my/following",
    component: _32f35084,
    name: "my-following"
  }, {
    path: "/my/publish",
    component: _67da547c,
    name: "my-publish"
  }, {
    path: "/my/purchase",
    component: _d18c9538,
    name: "my-purchase"
  }, {
    path: "/my/reading",
    component: _71287f79,
    name: "my-reading"
  }, {
    path: "/my/setting",
    component: _f5978586,
    name: "my-setting"
  }, {
    path: "/my/stock",
    component: _04896443,
    name: "my-stock"
  }, {
    path: "/portfolio/create",
    component: _00febb36,
    name: "portfolio-create"
  }, {
    path: "/topics/popular",
    component: _63109e7e,
    name: "topics-popular"
  }, {
    path: "/user/member",
    component: _4b9933be,
    name: "user-member"
  }, {
    path: "/black-gold/industry-revival/intro",
    component: _06e089ec,
    name: "black-gold-industry-revival-intro"
  }, {
    path: "/activity/20211115/:id?",
    component: _6ee2d468,
    name: "activity-20211115-id"
  }, {
    path: "/activity/kefu/:id?",
    component: _0072cab4,
    name: "activity-kefu-id"
  }, {
    path: "/black-gold/industry-revival/:columnId?",
    component: _389cd00e,
    name: "black-gold-industry-revival-columnId"
  }, {
    path: "/chiefCircle/detail/:id",
    component: _1e4fd9a9,
    name: "chiefCircle-detail-id"
  }, {
    path: "/chiefCircle/guide/:id",
    component: _dfe7e4a0,
    name: "chiefCircle-guide-id"
  }, {
    path: "/chiefCircle/search/:id",
    component: _7732fa80,
    name: "chiefCircle-search-id"
  }, {
    path: "/column/page/:id?",
    component: _66854e9a,
    name: "column-page-id"
  }, {
    path: "/community/post/:id?",
    component: _71a7f581,
    name: "community-post-id"
  }, {
    path: "/community/topics/:id?",
    component: _8f407af6,
    name: "community-topics-id"
  }, {
    path: "/market/hotRange/:type?",
    component: _5e75e94d,
    name: "market-hotRange-type"
  }, {
    path: "/market/marketRange/:type?",
    component: _d19fc6b0,
    name: "market-marketRange-type"
  }, {
    path: "/member/coreCapital/:stockId",
    component: _056ac166,
    name: "member-coreCapital-stockId"
  }, {
    path: "/news/page/:id?",
    component: _734ef354,
    name: "news-page-id"
  }, {
    path: "/member/articles/:groupId?/:subGroupId?",
    component: _8fd4b4dc,
    name: "member-articles-groupId-subGroupId"
  }, {
    path: "/portfolio/create/:type/:portfolioCode?",
    component: _77220750,
    name: "portfolio-create-type-portfolioCode"
  }, {
    path: "/portfolio/edit/:type?/:portfolioCode?",
    component: _7782674a,
    name: "portfolio-edit-type-portfolioCode"
  }, {
    path: "/album/:columnId?",
    component: _94aab3a0,
    name: "album-columnId"
  }, {
    path: "/chatroom/:id?",
    component: _fe6330a4,
    name: "chatroom-id"
  }, {
    path: "/hotpost/:type",
    component: _451bfdd7,
    name: "hotpost-type"
  }, {
    path: "/hotspot/:id",
    component: _4a54024c,
    name: "hotspot-id"
  }, {
    path: "/live/:id",
    component: _0ef28367,
    name: "live-id"
  }, {
    path: "/market/:id",
    component: _6be268b7,
    name: "market-id"
  }, {
    path: "/member/:id",
    component: _86147850,
    name: "member-id"
  }, {
    path: "/news/:id",
    component: _4a6af364,
    name: "news-id"
  }, {
    path: "/p/:id?",
    component: _080de57b,
    name: "p-id"
  }, {
    path: "/portfolio/:id",
    component: _b264f2d4,
    name: "portfolio-id"
  }, {
    path: "/rss-detail/:id?",
    component: _b4841eb2,
    name: "rss-detail-id"
  }, {
    path: "/stock/:id?",
    component: _22159bbe,
    name: "stock-id"
  }, {
    path: "/subject/:id",
    component: _1ebc0837,
    name: "subject-id"
  }, {
    path: "/tags/:type?",
    component: _b522e01a,
    name: "tags-type"
  }, {
    path: "/terms/:page?",
    component: _7c972346,
    name: "terms-page"
  }, {
    path: "/user/:id?",
    component: _73b96f46,
    name: "user-id"
  }, {
    path: "/portfolio/:id?/follow",
    component: _dfae61c6,
    name: "portfolio-id-follow"
  }, {
    path: "/portfolio/:id?/revenue-analysis",
    component: _5033e44e,
    name: "portfolio-id-revenue-analysis"
  }, {
    path: "/member/:id?/:childId",
    component: _30d316fc,
    name: "member-id-childId"
  }, {
    path: "/",
    component: _e542f99c,
    children: [{
      path: "",
      component: _70174796,
      name: "index"
    }, {
      path: "tag/:type?",
      component: _5741ee47,
      name: "index-tag-type"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
